import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { BasicAuthInterceptor } from "./interceptors/basic-auth.interceptor";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import {
  TranslateModule,
  TranslateService,
  TranslateLoader,
} from "@ngx-translate/core";
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
import { AppComponent } from "./app.component";
// Import containers
import { DefaultLayoutComponent } from "./containers";
import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from "@coreui/angular";
// Import routing module
import { AppRoutingModule, routes } from "./app.routing";
// Import 3rd party components
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TabsModule } from "ngx-bootstrap/tabs";
import { ChartsModule } from "ng2-charts/ng2-charts";
import { MomentModule } from "ngx-moment";
import { NgxSpinnerModule } from "ngx-spinner";
import { ICObjectiveService } from "./services/icobjective.service";
import { ICUserService } from "./services/icuser.service";
import { ICAreaService } from "./services/icarea.service";
import { ICCameraService } from "./services/iccamera.service";
import { LoginModule } from "./views/login/login.module";
import { ToasterService, ToasterModule } from "angular2-toaster";
import { PipeModule } from "./pipes/pipe.module";
import { AreaSelectorModule } from "./views/shared/area-selector/area-selector.module";
import { AreaTreeModule } from "./views/shared/area-tree/area-tree.module";
import { ICSchedulationService } from "./services/icschedulation.service";
import { ICFolderService } from "./services/icfolder.service";
import {
  RouterModule,
  PreloadAllModules,
  PreloadingStrategy,
  NoPreloading,
} from "@angular/router";
import { SortablejsModule } from "ngx-sortablejs";
import { DBConfig, NgxIndexedDBModule } from "ngx-indexed-db";
import { SialinkComponent } from "./views/sialink/sialink.component";

const CacheDbConfig: DBConfig = {
  name: "Cache",
  version: 1,
  objectStoresMeta: [
    {
      store: "cache",
      storeConfig: { keyPath: "id", autoIncrement: true },
      storeSchema: [
        { name: "key", keypath: "key", options: { unique: true } },
        { name: "value", keypath: "value", options: { unique: false } },
      ],
    },
  ],
};

const APP_CONTAINERS = [DefaultLayoutComponent];
const APP_SERVICES = [
  ICUserService,
  ICAreaService,
  ICFolderService,
  ICSchedulationService,
  ICObjectiveService,
  ICCameraService,
];
@NgModule({
  imports: [
    MomentModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    NgxSpinnerModule,
    AppHeaderModule,
    AppSidebarModule,
    LoginModule,
    ToasterModule,
    SortablejsModule.forRoot({ animation: 150 }),
    PipeModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    AreaSelectorModule,
    AreaTreeModule,
    HttpClientModule,
    NgxIndexedDBModule.forRoot(CacheDbConfig),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading }),
    AppRoutingModule,
  ],
  declarations: [AppComponent, ...APP_CONTAINERS, SialinkComponent],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BasicAuthInterceptor,
      multi: true,
    },
    ToasterService,
    TranslateService,
    ...APP_SERVICES,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
